
import LayoutDefault from "@/components/layout/default/LayoutDefault.vue";
import SquadService from "@/services/auth/SquadService";
import ActionService from "@/services/lead/ActionService";
import "datatables.net-colreorder-dt";
import "datatables.net-buttons-bs4";
import "datatables.net-buttons/js/buttons.colVis";
import "datatables.net-fixedcolumns-bs4";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net";
import "datatables.net-buttons";
import { Money } from 'v-money';
import Multiselect from "vue-multiselect";
import { Component, Vue, Watch } from "vue-property-decorator";
import vSelect from "vue-select";
import DateRangePicker from "vue2-daterange-picker";
import { mapGetters } from "vuex";


@Component({
  components: {
    LayoutDefault,
    DateRangePicker,
    Money,
    Multiselect,
    vSelect
  },

  computed: {
    ...mapGetters('auth', ['allowedFeature'])
  },
})
export default class Squad extends Vue {
  private allowedFeature: any;

  private squadService = new SquadService();
  private actionService = new ActionService();

  /**
   * @type Object
   * Data list lead from return backend
   */
  private listSquad: any;
  private listAction: any;
  private editing: boolean = false;
  private loadingModal: boolean = false;

  /**
   * @type Object
   * list returned from backend
   */
  private squadList: any = [];
  private actionListPlatform: any = [];
  private actionList: any = [];

  private userFormError = {
    name: { state: null as boolean | null, message: "" },
    nickname: { state: null as boolean | null, message: "" },
    action: { state: null as boolean | null, message: "" },
  };

  /**
   * @type Object
   * insert commission
   */

   private itemsTriggers: {
          trigger: string,
          trigger_key: string,
          trigger_value: string,
          commission_value: string,
          per_attendance_value: string,
          daily_minimum_value: string,
    }[] = [];

  private typeSquadList = [
    { key: 'Valor', label: 'Valor', name: "amount" },
    { key: 'Quantidade', label: 'Quantidade', name: 'count' },
  ];

  private constractSquadList = [
    { key: 'PJ', label: 'PJ - MEI', name: 1 },
    { key: 'PA', label: 'PA - CLT', name: 0 },
  ];

  /**
   * @type boolean
   */
  private validatingCommissionNull: boolean = false;
  private loading: boolean = false;

  /**
   * @tyoe Array
   * Define columns from datatables
     */
    private columnsSquad = [
        { data: "id_squad", name: "id_squad", title: "ID", orderable: false, defaultContent: ""},
        { data: "name", name: "name",title: "Nome do Squad",orderable: true,},
        { data: "is_pj", name: "is_pj",title: "PJ",orderable: true,},
        { data: "actions",name: "actions",title: "Ações",orderable: true,},
        { data: "type_metric",name: "type_metric",title: "Tipo de metrica",orderable: true,},
        { data: "date_created",name: "date_created",title: "Criado",orderable: true,},
        { title: "Ações", orderable: false, overflow: "hidden", className: "nowrap", width: "auto", right: 1, position: "relative",
            render: (data, type, row) => {
              return  " <a class=\"btn-edit-squad\" style=\"color: #172542;\"><i name="+row['id_squad']+" class='fas fa-edit fa-lg'></i></a>";
            }
          },
    ];

    private columnsAction = [
        { data: "id_action", name: "id_action", title: "ID", orderable: false, defaultContent: ""},
        { data: "label_action", name: "label_action", title: "Nome da Ação", orderable: true},
        { data: "name", name: "name", title: "Nome",orderable: true},
        { data: "description",name: "description",title: "Descrição",orderable: true},
        { data: "label",name: "label",title: "Status",orderable: true},
        { data: "date_created",name: "date_created",title: "Criado",orderable: true},
    ];

    private squad:any = {
        squad_name: null as null | string,
        is_pj: null as null | string | any,
        type_metric: null as null | string | any,
        id_platform: null as null | number,
        actions: [] as any | [],
        squad_id: null as null | number
    }

  /**
   * @type Array
   * Set config for buttons datatable
   */
  private buttons: any = [];

  private is_pj: any = null;
  private type_metric: any = null;
  private actions: any;

  private editSquad:any = false

  /**
   * Method close modal from add new commission and reset commission state
   */
  private closeSquadActionModal() {
    this.hideModal("modal-add-squad-action");

    this.editSquad = false;
    this.validatingCommissionNull = false;

    this.squad.id_platform = this.$auth.user().id_platform,
    this.squad.type_metric = null;
    this.squad.actions = null;
    this.squad.is_pj = null;
    this.squad.squad_name = null;
    this.is_pj = null;
    this.type_metric = null;
    this.actions = null;
  }

  private removeItemsTrigger(item, index, element) {
    this.itemsTriggers.splice(index, 1);
  }

  private typeMetricSelected() {
    if(this.type_metric && this.type_metric.name)
      this.squad.type_metric = this.type_metric.name;
  }

  private constractSelected() {
      this.squad.is_pj = this.is_pj.name;
  }

  private async actionSelected(selectedOption) {
    if(this.squad && this.squad.actions.length > 0) {
        this.squad.actions = [];
    }

    this.squad.actions = selectedOption.map((e) => e.id_action);
  }

  /**
   * Method join commands for create datatable
   */
  private createDataTableSquad() {
    if (!this.allowedFeature('edit-squad')){
        const chaves = Object.keys(this.columnsSquad);
        const ultimaChave = chaves[chaves.length - 1];
        delete this.columnsSquad[ultimaChave];
    }

    this.listSquad = this.$('#listSquad').DataTable({
      autoWidth: false,
      scrollCollapse: true,
      paging: false,
      fixedColumns: true,
      responsive: true,
      processing: true,
      order: [[0, "desc"]],
      lengthMenu: [
        [25, 50, 100],
        [25, 50, 100],
      ],
      pageLength: 25,
      scrollY: 500,
      scrollX: true,
      dom: '<"row"<"col-sm-12 col-md-5"l><"col-sm-12 col-md-7"f>>Brt<"row"<"col-sm-12 col-md-5"i><"col-sm-12 col-md-7"p>>',
      ajax: {
        url: `${process.env.VUE_APP_ROOT_API}auth/squad/platform/${this.$auth.user().id_platform}`,
        dataSrc: "",
        crossDomain: true,
        type: "GET",
        beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", 'Bearer ' + localStorage.getItem('token'));
        }
      },
      columnDefs: [
        {
            className: "nowrap",
        }
      ],
      columns: this.columnsSquad,
      language: {
        sEmptyTable: "Nenhum registro encontrado",
        sInfo: "Mostrando de _START_ até _END_ de _TOTAL_ registros",
        sInfoEmpty: "Mostrando 0 até 0 de 0 registros",
        sInfoFiltered: "(Filtrados de _MAX_ registros)",
        sInfoPostFix: "",
        sInfoThousands: ".",
        sLengthMenu: "_MENU_ Qtd por página",
        sLoadingRecords: "Carregando...",
        sProcessing:
          '<div><div class="row justify-content-center m-5"><span role="status" class="spinner-border" style="width: 3rem; height: 3rem;"></span></div><div class="row justify-content-center mt-5">Loading ...</div></div>',
        sZeroRecords: "Nenhum registro encontrado",
        oPaginate: {
          sNext: "Próximo",
          sPrevious: "Anterior",
          sFirst: "Primeiro",
          sLast: "Último"
        },
        oAria: {
          sSortAscending: ": Ordenar colunas de forma ascendente",
          sSortDescending: ": Ordenar colunas de forma descendente"
        },
        select: {
          rows: {
            _: "Selecionado %d linhas",
            "0": "Nenhuma linha selecionada",
            "1": "Selecionado 1 linha"
          }
        }
      },
      buttons: this.buttons,
      drawCallback: () => {
        this.$(".editButton").click(e => {
          this.$bvModal.show("modal-add-squad-action");
        });

        this.$(".btn-edit-squad").click(e => {
            let id_squad = this.$(e.target).attr('name');
            this.$bvModal.show("modal-add-squad-action");
            this.getValueEditSquad(id_squad);
        });
      }
    });

    this.listSquad.buttons().container().appendTo("#dt-actions");
  }

  private createDataTableActon() {

    if (this.allowedFeature('create-squad'))
        this.buttons.push({ extend: "addSquadAction" });

    this.listAction = this.$('#listAction').DataTable({
      autoWidth: true,
      scrollCollapse: true,
      paging: true,
      fixedColumns: true,
      responsive: true,
      processing: true,
      order: [[0, "desc"]],
      lengthMenu: [
        [25, 50, 100],
        [25, 50, 100],
      ],
      pageLength: 25,
      scrollY: 500,
      scrollX: true,
      dom: '<"row"<"col-sm-12 col-md-5"l><"col-sm-12 col-md-7"f>>Brt<"row"<"col-sm-12 col-md-5"i><"col-sm-12 col-md-7"p>>',
      ajax: {
        url: process.env.VUE_APP_ROOT_API + "auth/action/platform/" + this.$auth.user().id_platform,
        dataSrc: "",
        crossDomain: true,
        type: "GET",
        beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", 'Bearer ' + localStorage.getItem('token'));
        }
      },

      columns: this.columnsAction,
      language: {
        sEmptyTable: "Nenhum registro encontrado",
        sInfo: "Mostrando de _START_ até _END_ de _TOTAL_ registros",
        sInfoEmpty: "Mostrando 0 até 0 de 0 registros",
        sInfoFiltered: "(Filtrados de _MAX_ registros)",
        sInfoPostFix: "",
        sInfoThousands: ".",
        sLengthMenu: "_MENU_ Qtd por página",
        sLoadingRecords: "Carregando...",
        sProcessing:
          '<div><div class="row justify-content-center m-5"><span role="status" class="spinner-border" style="width: 3rem; height: 3rem;"></span></div><div class="row justify-content-center mt-5">Loading ...</div></div>',
        sZeroRecords: "Nenhum registro encontrado",
        oPaginate: {
          sNext: "Próximo",
          sPrevious: "Anterior",
          sFirst: "Primeiro",
          sLast: "Último"
        },
        oAria: {
          sSortAscending: ": Ordenar colunas de forma ascendente",
          sSortDescending: ": Ordenar colunas de forma descendente"
        },
        select: {
          rows: {
            _: "Selecionado %d linhas",
            "0": "Nenhuma linha selecionada",
            "1": "Selecionado 1 linha"
          }
        }
      },
      buttons: this.buttons,
      drawCallback: () => {
        this.$(".editButton").click(e => {
          this.$bvModal.show("modal-add-squad-action");
        });
      }
    });

    this.listAction.buttons().container().appendTo("#dt-actions");
  }

  /**
   * Method mounted from life cycle
   */
  private async mounted() {
    let self = this;

    this.$.fn.dataTable.ext.buttons.addSquadAction = {
      text: '<i class="fas fa-plus"></i>',
      className: "datatable-buttons pr-0 pl-0",
      titleAttr: "Adicionar regra de squad",
      action: function (e, dt, node, config) {
        self.$bvModal.show("modal-add-squad-action");
      }
    };

    this.squadList = await this.squadService.show(this.$auth.user().id_platform);
    this.actionListPlatform = await this.actionService.showActions(this.$auth.user().id_platform);
    this.actionList = await this.actionService.showAllAction();

    try {
      this.createDataTableSquad();
      this.createDataTableActon();
    } catch (error) {
      console.log(error);
    }
  }

   private async addSquad() {
    this.squad.id_platform = this.$auth.user().id_platform;
    this.squad.actions = this.squad.actions.map(e => e.id_action);
    this.validatingCommissionNull = true;
    this.loading = true;

    try {
        if(this.squad.actions.length > 0 && !this.editSquad){
            this.squad.squad_id = null;
            await this.squadService.store(this.$auth.user().id_platform, this.squad);
        }else if(this.editSquad){
            await this.squadService.update(this.$auth.user().id_platform, this.squad);
        }

        this.loading = false;
        this.$store.commit("navBarAlert/SUCCESS_ALERT", "Squad salvo com sucesso");
    } catch (error) {
        console.log(error);

        this.loading = false;
        this.$store.commit("navBarAlert/DANGER_ALERT", "Erro ao salvar squad");
    }

    this.listSquad.ajax.reload();
    this.closeSquadActionModal();
  }

  private async getValueEditSquad(id_squad:number){
    this.loading = true;

    try {
        const valueEditSquad = await this.squadService.showSquad(
            this.$auth.user().id_platform,
            id_squad
        );

        this.squad.squad_id = id_squad;
        this.squad.squad_name = valueEditSquad[0].name;
        this.squad.is_pj = (this.constractSquadList.find(e => e.label == valueEditSquad[0].is_pj)as any).name;
        this.squad.type_metric = ((this.typeSquadList.find(e => e.label == valueEditSquad[0].type_metric)) as any).name;
        this.squad.actions = this.actionListPlatform.find((e) => valueEditSquad[0].actions.split(',').includes(e.label_action));

        this.is_pj = this.constractSquadList.find(e => e.label == valueEditSquad[0].is_pj);
        this.type_metric = this.typeSquadList.find(e => e.label == valueEditSquad[0].type_metric);
        this.editSquad = true;
    } catch (error) {
        console.log(error);

    }
    this.loading = false;
  }

  private hideModal(modal_id: string) {
    this.$bvModal.hide(modal_id);
  }

  /**
   * Method before create from life cycle
   */
  private beforeCreate() {
    document.body.className = "";
  }

  private get nameSquadState() {
     return (!this.validatingCommissionNull && !this.squad.squad_name ) ? null :
     (this.validatingCommissionNull && !this.squad.squad_name) ? false : true;
  }

   private get actionSquadState() {
     return (this.squad && !this.validatingCommissionNull && !this.squad.actions ) ? null :
     (this.validatingCommissionNull && this.squad && !this.squad.actions) ? false : true;
  }
}
